import * as React from 'react';

export interface IDropdownOption {
    id: string;
    display: string;
}

export interface IDropdownOptionProps {
    value: IDropdownOption;
    onDropdownSelect: () => void;
    name?: string
}

export function DropdownOption({ name, value, onDropdownSelect }: IDropdownOptionProps) {
    const id = `${name}-${value.id}`;

    return (
        <option value={value.id}
            id={id}
            onClick={onDropdownSelect}>
            {value.display}
        </option>
    );
};

export interface IDropdownSelectProps {
    values: IDropdownOption[];
    selectedId?: string;
    display?: string;
    placeHolder?: string;
    onDropdownSelect: (id: string | number) => void;
    name?: string;
}

export function DropdownSelect({ values, selectedId = '', display = '', placeHolder = '', onDropdownSelect, name }: IDropdownSelectProps) {
    const [, forceUpdate] = React.useReducer(x => x + 1, 0);
    const renderOptions = (value: IDropdownOption, index: number) => {
        return <DropdownOption
            name={`${name}-index`}
            onDropdownSelect={forceUpdate}
            key={index}
            value={value} />
    };

    const getValues = () => {
        if (placeHolder) {
            return [Object.freeze({ id: '', display: placeHolder })].concat(values);
        }
        return values;
    }


    return (
        <div className="adage-search-select">
            <select
                onChange={(e: React.ChangeEvent<HTMLSelectElement>) => onDropdownSelect((e.target as HTMLSelectElement).value)}
                value={selectedId}
            >
                {getValues().map(renderOptions)}
            </select>
        </div>
    );
}
